import { useState } from "react";
import { useReveal } from "@/hooks/useReveal";

const FAQS = [
  {
    q: "Will you sell a competing brand into my market?",
    a: "Territory and channel arrangements are agreed in writing before the first run. Bring it up on the first call, not the last.",
  },
  {
    q: "Can I use your organic certification on my pack?",
    a: "Your own certifier reviews your label and decides how the claim is made. We supply the plant certificates, the process documentation and the batch records they will ask for.",
  },
  {
    q: "Who owns the artwork and the specification?",
    a: "You do. We hold the dieline and the technical file for production purposes only.",
  },
  {
    q: "Can you pass our supplier audit?",
    a: "The plant holds HACCP and INVIMA registration and is audited annually by Ecocert. We can send the supplier questionnaire pack and traceability records ahead of any visit.",
  },
  {
    q: "What if my volume is below your minimum?",
    a: "We will say so directly and, where we can, point you to a consolidator or a local distributor. We would rather lose the enquiry than take a run we cannot serve properly.",
  },
  {
    q: "How do samples work?",
    a: "We can supply product samples by prior agreement, but the buyer must bear the shipping costs for said samples. Samples of packaging featuring your design are manufactured during the pilot production phase.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Questions we are always asked
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="border border-cream-dark/60 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                >
                  <span className="text-ink font-serif text-base md:text-lg font-semibold">
                    {item.q}
                  </span>
                  <i
                    className={`text-brown text-xl transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-ink/70 text-[17px] leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}